import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-50882020"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['activity-invited-box'])
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "邀请函", -1));
const _hoisted_3 = {
  class: "invited-operate-box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: "https://p6.moimg.net/md/activity/recommend/invite_bg_icon.png"
}, null, -1));
const _hoisted_5 = {
  class: "invited-operate"
};
const _hoisted_6 = {
  class: "inviter-box"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "name"
};
const _hoisted_9 = {
  class: "invited-info"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/activity/recommend/invite_des.png"
}, null, -1));
const _hoisted_11 = {
  class: "invited-info-des"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-value"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "marginB"
}, "众筹就是通过「团购+预售」的形式募集到启动资金。"), /*#__PURE__*/_createElementVNode("div", null, "摩点采用「all-or-nothing」的筹资模式，如果您达到筹资目标，平台将收取6%起手续费；若未达到不收取任何费用，筹到的资金返回给用户")], -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "collapse-item-value collapse-item-ul"
}, [/*#__PURE__*/_createElementVNode("li", {
  class: "collapse-item-li marginB"
}, "门槛低：不开店，无押金"), /*#__PURE__*/_createElementVNode("li", {
  class: "collapse-item-li"
}, "成本低：先卖货后生产，无库存压力"), /*#__PURE__*/_createElementVNode("li", {
  class: "collapse-item-li"
}, "周期短：众筹项目周期60天"), /*#__PURE__*/_createElementVNode("li", {
  class: "collapse-item-li"
}, "结算快：项目众筹成功马上结算")], -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-value"
}, " 有创新创业能力的人，有类似问题如缺少启动资金、不想存货压力、先试市场反应等。保证产品是首次独家发售，可通过一次众筹，在产品完成之前就募集一部分生产所需的资金，并可按量生产。 ", -1));
const _hoisted_15 = {
  class: "invite-info-tips-box"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/md/activity/recommend/invite_info_tips.png"
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, "你已是摩点老项目发起人，可继续浏览活动或去邀请其他项目发起人", -1));
const _hoisted_18 = {
  class: "btn-group"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "invite-success-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/md/activity/recommend/invite_success_icon.png"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, "你已接受ta的邀请，快添加你的专属客服吧")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_van_collapse_item = _resolveComponent("van-collapse-item");
  const _component_van_collapse = _resolveComponent("van-collapse");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [!$data.env.isWxApp() && !$data.env.isWeixin() ? (_openBlock(), _createBlock(_component_van_sticky, {
    key: 0,
    onChange: $options.handleStickyAction
  }, {
    default: _withCtx(() => [_createElementVNode("header", {
      class: _normalizeClass([{
        'headerAndroid': $data.env.isModianAndroid()
      }, {
        'isFix': $data.isFix
      }])
    }, [_createVNode(_component_van_image, {
      class: "back-btn",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/nav_back_btn.png', 32),
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.handleGoBack(), ["stop"]))
    }, null, 8, ["src"]), _hoisted_2], 2)]),
    _: 1
  }, 8, ["onChange"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    class: "icon",
    src: _ctx.$imgUrlFilter($data.cpInfo.icon, 72)
  }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, _toDisplayString($data.cpInfo.nickname), 1)]), _createElementVNode("img", {
    class: "invited-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.accecptInvited && $options.accecptInvited(...args)),
    src: "https://p6.moimg.net/md/activity/recommend/invite_btn.png"
  })])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_collapse, {
    modelValue: $data.activeNames,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.activeNames = $event),
    border: false
  }, {
    default: _withCtx(() => [_createVNode(_component_van_collapse_item, {
      class: "collapse-item",
      "title-class": "collapse-item-tit",
      title: "众筹介绍",
      name: "1",
      border: false
    }, {
      default: _withCtx(() => [_hoisted_12]),
      _: 1
    }), _createVNode(_component_van_collapse_item, {
      class: "collapse-item",
      "title-class": "collapse-item-tit",
      title: "摩点众筹的优势",
      name: "2",
      border: false
    }, {
      default: _withCtx(() => [_hoisted_13]),
      _: 1
    }), _createVNode(_component_van_collapse_item, {
      class: "collapse-item",
      "title-class": "collapse-item-tit",
      title: "适合那些人发起众筹",
      name: "3",
      border: false
    }, {
      default: _withCtx(() => [_hoisted_14]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])])]), _createVNode(_component_van_popup, {
    show: $data.showTips,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $data.showTips = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_hoisted_16, _hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
      class: "btn",
      onClick: _cache[3] || (_cache[3] = (...args) => $options.goTenth && $options.goTenth(...args))
    }, "去浏览活动"), _createElementVNode("div", {
      class: "btn",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.goRecommend && $options.goRecommend(...args))
    }, "我要邀请")])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.showSuccess,
    "onUpdate:show": _cache[6] || (_cache[6] = $event => $data.showSuccess = $event)
  }, {
    default: _withCtx(() => [_hoisted_19]),
    _: 1
  }, 8, ["show"])])]);
}